import { useSelector } from 'react-redux';

import ordersSelector from '../../../../../redux/selectors/orders-selectors';

export function useShowSuccessSection(): boolean {
  return useSelector(
    ordersSelector.selectIsOrderTotalsSuccessfulInOrderDetailDialog,
  );
}
